import { getProduct } from '@/services/api/product';
import { getChannelId, getNationCode } from '@/utils/channel';

// 机型名称与图片统一通过 getProduct 接口获取；
// 接口不返回 sku 规格与价格，这两类字段仍沿用估价结果。
export default {
  data() {
    return {
      productInfo: null
    };
  },
  computed: {
    apiProductName() {
      return (this.productInfo && this.productInfo.productName) || '';
    },
    apiProductLogo() {
      return (this.productInfo && this.productInfo.productLogo) || '';
    }
  },
  methods: {
    fetchProductInfo(productId) {
      if (!productId) {
        return Promise.resolve(null);
      }
      return getProduct({
        productId,
        channelId: getChannelId(),
        nation: getNationCode()
      })
        .then(res => {
          if (res.code === '0000' && res.data) {
            this.productInfo = res.data;
            return res.data;
          }
          return null;
        })
        .catch(err => {
          console.error('[fetchProductInfo]', err);
          return null;
        });
    },
    // 接口未返回时沿用原有数据，避免机型卡片空白
    withProductInfo(source) {
      const data = source || {};
      return {
        ...data,
        skuName: this.apiProductName || data.skuName,
        productName: this.apiProductName || data.productName,
        productLogo: this.apiProductLogo || data.productLogo
      };
    }
  }
};
